(ns iris.login.subs
  (:require 
   [re-frame.core :as re-frame]))

(re-frame/reg-sub
 ::error-message
 (fn [db]
   (get-in db [:login :error-message])))

(re-frame/reg-sub
 ::success-message
 (fn [db]
   (get-in db [:login :success-message])))

(re-frame/reg-sub
 ::login-reset-needed
 (fn [db]
   (get-in db [:login :reset-needed])))